"use client"

import dynamic from "next/dynamic"

// Lazy load navigation with ssr: false - must be in a Client Component
const TopNavigationWithSessionProvider = dynamic(
    () => import("@/components/top-navigation-with-session-provider").then(
        (m) => m.TopNavigationWithSessionProvider
    ),
    {
        ssr: false,
        loading: () => <nav className="w-full h-14 bg-brand border-b border-border" aria-label="Loading navigation" />,
    }
)

// Re-export for use in Server Component layout
export function ClientNavigation() {
    return <TopNavigationWithSessionProvider />
}
